/**
 * Human-readable label for an agent tool name, used wherever a tool call is
 * shown to an operator — the chat's tool-run rows and the tool-confirmation
 * prompt. Tool names are snake_case verb phrases that humanize cleanly
 * (`delete_routine` → `Delete routine`), so `OVERRIDES` carries only the
 * names whose mechanical form reads badly.
 */
// A Map, not an object literal: `toolName` is model-supplied and reaches
// here unvalidated, and a plain-object lookup for `toString` or `__proto__`
// would return an inherited non-string.
const OVERRIDES = new Map<string, string>([
  // Humanizes to a dangling preposition ("Navigate to").
  ['navigate_to', 'Navigate'],
  // Not a verb phrase, so the mechanical form reads as a noun.
  ['routine_code_docs', 'Read routine code docs'],
]);

export function toolDisplayName(toolName: string): string {
  const override = OVERRIDES.get(toolName);

  if (override !== undefined) return override;

  const words = toolName
    .trim()
    .split(/[_\s]+/)
    .filter(Boolean);

  if (words.length === 0) return toolName;

  const [first, ...rest] = words;

  return [first.charAt(0).toUpperCase() + first.slice(1), ...rest].join(' ');
}
